module.exports = __webpack_public_path__ + "static/img/gq5.671df564.jpg";